import { formatPhone } from "shared-ts/utils"

import { data } from "./data"
import { TypedAccessor } from "./types"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type PhoneAccessorFn<T> = TypedAccessor<T, string | undefined>
type PhoneColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type PhoneColumnHelper<T> = (
  accessorFn: PhoneAccessorFn<T>,
  col: PhoneColumn<T>
) => DataColumn<T>

export function phone<T>(
  accessorFn: PhoneAccessorFn<T>,
  col: PhoneColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const value = accessorFn(rowData)
      if (!value) return null
      return formatPhone(value)
    },
    width: TableCellWidth.Large,
    ...col,
  })
}
